module.exports = __webpack_public_path__ + "img/close-outline-white.92fcebb6.svg";